module.exports = __webpack_public_path__ + "static/media/jumping.4bd41f49.png";